import { Component, OnInit } from '@angular/core';
// import { AuthService } from '../services/auth.service'; // Adjust the path based on your structure

@Component({
    selector: 'app-pre-login',
    templateUrl: './pre-login.component.html',
    styleUrls: ['./pre-login.component.scss'],
    standalone: false
})
export class PreLoginComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    
  }
}
